export default "__VITE_ASSET__ac999920__"